import { render, staticRenderFns } from "./VimeoVideoModal.vue?vue&type=template&id=c3c1923c&v-if=videoUrl&"
import script from "./VimeoVideoModal.vue?vue&type=script&lang=ts&"
export * from "./VimeoVideoModal.vue?vue&type=script&lang=ts&"
import style0 from "./VimeoVideoModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports